@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.modalBody {
  width: fit-content !important;
}

.modalContent {
  padding-bottom: 24px;
}

.modalHeader {
  padding: 12px 20px !important;
}

.paywallHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .leftControls {
    display: flex;
    align-items: center;

    button,
    a {
      color: var(--dark-80);
      height: 32px;
      min-height: 32px;
    }
  }

  .rightControls {
    display: flex;
    align-items: center;

    button,
    a {
      color: var(--dark-80);
      height: 32px;
      min-height: 32px;
    }
  }
}

.mainContainer {
  background-color: var(--light-100);
  border-radius: 15px;
  max-width: 980px;
  position: relative;
  padding: 40px 20px 20px 20px;
}

.contentConstraint {
  max-width: 80%;
  padding: 10px 0 20px 0;
  margin: 0 auto;
  width: 100%;

  @include for-phone-only {
    margin: 0;
    max-width: 100%;
  }
}

.contentWrapper {
  display: flex;
  flex-direction: column;
  gap: 25px;
  align-items: center;
}

.headerSection {
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: 100%;
}

.titleSection {
  text-align: center;

  h1 {
    font-size: 48px;
    font-weight: 600;
    color: var(--dark-80);
    padding-bottom: 15px;
  }
}

.subtitle {
  font-size: 16px;
  color: var(--dark-80);
  line-height: 1.4;
  text-align: center;
}

.featureCards {
  display: flex;
  gap: 15px;
  width: 100%;
}

.featureCard {
  flex: 1;
  background-color: rgba(153, 224, 240, 0.25);
  border-radius: 25px;
  padding: 15px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.featureIcon {
  height: 30px;
  width: 30px;
}

.featureText {
  font-size: 14px;
  color: var(--dark-80);
  line-height: 1.4;
}

.warningSection {
  background-color: var(--dark-3);
  border-radius: 15px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.warningText {
  @include sm-sohne-medium;
  color: var(--Dark-80, rgba(0, 0, 0, 0.8));
}

.ctaSection {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.primaryButton {
  border-radius: 99px;
  background: linear-gradient(90deg, #6800ec 0%, #ea00db 100%);
  display: flex;
  padding: 12px 15px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: var(--light-100);
  font-size: 16px;
  font-weight: 600;
  border: none;

  &:hover {
    opacity: 0.9;
  }
}

.ctaSubtext {
  @include xs-sohne-book;
  color: var(--Dark-60, rgba(0, 0, 0, 0.6));
  text-align: center;
}

.mobileBottomCta {
  width: 100%;
  margin-bottom: 20px;
}

.demoSection {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  margin: 10px 0;

  @include for-phone-only {
    align-items: center;
  }
}

.demoPrompt {
  @include xs-sohne-medium;
  color: var(--Dark-80, rgba(0, 0, 0, 0.8));
  text-align: center;
  max-width: max-content;
  font-weight: 500;
  font-size: 14px;
}

.demoButton {
  background-color: #eee4ff;
  border: 1px solid var(--dark-8);
  border-radius: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 48px;
  padding: 8px 8px 8px 10px;

  @include for-phone-only {
    width: 100%;
    justify-content: center;
  }

  &:hover {
    background-color: #e0d1ff;
    border-color: var(--dark-12);
  }
}

.demoButtonContent {
  display: flex;
  align-items: center;
  gap: 8px;
}

.avatarContainer {
  background-color: #bb5bff;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  position: relative;
  overflow: hidden;
}

.avatar {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.demoButtonText {
  color: var(--dark-80);
  font-size: 14px;
  font-weight: 600;
}

.loyaltyBanner {
  background-color: #f7f7f7;
  border-radius: 10px;
  padding: 12px 20px;
  margin: 20px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.loyaltyText {
  @include md-sohne-medium;
  color: var(--Magenta-70, #7f24b7);
}

.modalFooter {
  border-top: 1px solid var(--dark-8);
  padding: 20px 24px;
}

.footerLeft {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

@media (max-width: $responsiveSmall) {
  .mainContainer {
    width: 600px;
    padding: 30px 20px;
  }

  .featureCards {
    flex-direction: column;
    gap: 15px;
  }

  .mainTitle h1 {
    font-size: 36px;
  }

  .subtitle {
    font-size: 16px;
  }
}

@media (max-width: $phoneMaxWidth) {
  .mainContainer {
    width: 500px;
    padding: 20px 15px;
  }

  .mainTitle h1 {
    font-size: 28px;
  }
}

@media (max-width: $phoneMdMaxWidth) {
  .mainContainer {
    width: unset;
  }
}
